import ajax from "@/lib/ajax";

// 查询腹透挂号患者列表
export async function QueryRegisters() {
    let res = await ajax.get(`/api/services/app/PDRegister/QueryRegisters`);
    return res.data.result;
}

// 患者接诊
export async function AcceptRegister(payload: any) {
    let res = await ajax.post(`/api/services/app/PDRegister/AcceptRegister`, payload);
    return res.data.result;
}
// 查询腹透挂号患者列表
export async function QueryRegistersList(payload: any) {
    let res = await ajax.get(`/api/services/app/PDRegister/QueryRegistersList`, {params:payload});
    return res.data.result;
}



// WEBPACK FOOTER //
// ./src/api/pdOutPatient/pdOutPatientIndex/index.ts